import {ICONS, PrintHOC, Slider} from "../../../components";
import {ESignaturePane} from "../../ESignature";
import {ForeignDeviceWaiver} from "../prints/ForeignDeviceWaiver";
import {TicketPrint} from "../../../api";
import React from "react";
import {IphoneCrossBorderForm} from "../prints/IphoneCrossBorderForm";
import {WatchReleaseOfLiabilityForm} from "../prints/WatchReleaseofLiability";
import {Button, Col, Row} from "react-bootstrap";
import {TicketService} from "../../../services";
import {showSuccessToast} from "../../../state/toasts";
import {useDispatch} from "react-redux";
import {IPhone14SeriesDisclaimerForm} from "../prints/IPhone14SeriesDisclaimerForm";


export type DisclaimerFormProps={
    ticket:TicketPrint
}

export const ForeignDeviceWaiverSlider=({ticket}:DisclaimerFormProps)=>{
        const dispatch = useDispatch()
    const ForeignDeviceWaiverPrint = PrintHOC(ForeignDeviceWaiver,  <span className="m-3">
         <><Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email('foreign_device_waiver').then(()=>{
     dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })
                  }}>{ICONS.EMAIL}</Button>
             <ESignaturePane
            id={ticket.id}
            guid={ticket.guid}
            url={ticket.url}
            type={"foreign_device_waiver"}
            code={ticket.reference_number}
          ></ESignaturePane></>
        </span>)

    return (
        <Row>
            <Col xs={10}>
            <Slider style={{width:"100%"}} size={"md"} variant="dark"
                    title="IPhone 12 and 13 Series">
              <ForeignDeviceWaiverPrint ticket={ticket} />
            </Slider>
                </Col>
              <Col xs={2}>
                  <Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email('foreign_device_waiver').then(()=>{
     dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })
                  }}>{ICONS.EMAIL}</Button>
              </Col>
            </Row>
  )
}

export const IphoneCrossBorderFormSlider=({ticket}:DisclaimerFormProps)=> {
        const dispatch = useDispatch()
    const IphoneCrossBorderFormPrint = PrintHOC(IphoneCrossBorderForm, <span className="m-3">
        <> <Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email(
                          'iphone_cross_border_disclaimer').then(()=>{
                                   dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })}}>{ICONS.EMAIL}</Button>
          <ESignaturePane
              id={ticket.id}
              guid={ticket.guid}
              url={ticket.url}
              type={"iphone_cross_border"}
              code={ticket.reference_number}
          ></ESignaturePane></>
        </span>)

    return (
         <Row>
            <Col xs={10}>  <Slider style={{width:"100%"}}
                                   size={"md"} variant="dark" title="Iphone 11 and below models">
            <IphoneCrossBorderFormPrint ticket={ticket}/>
        </Slider></Col>
              <Col xs={2}>
                  <Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email(
                          'iphone_cross_border_disclaimer').then(()=>{
                                   dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })}}>{ICONS.EMAIL}</Button>
              </Col>
            </Row>
    )
}

export const WatchReleaseOfLiabilityFormSlider=({ticket}:DisclaimerFormProps)=> {
    const dispatch = useDispatch()
    const WatchReleaseOfLiabilityFormPrint = PrintHOC(WatchReleaseOfLiabilityForm,
        <span className="m-3">
            <> <Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email(
                          'watch_release_of_liability').then(()=>{
                                    dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })}}>{ICONS.EMAIL}</Button>     <ESignaturePane
              id={ticket.id}
              guid={ticket.guid}
              url={ticket.url}
              type={"watch_release_of_liability"}
              code={ticket.reference_number}
          ></ESignaturePane></>
        </span>)

    return (
        <Row>
            <Col xs={10}>
                <Slider style={{width:"100%"}} size={"md"} variant="dark"
                        title="Apple Watch Cellular">
            <WatchReleaseOfLiabilityFormPrint ticket={ticket}/>
                </Slider>
                </Col>
              <Col xs={2}>
                  <Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email(
                          'watch_release_of_liability').then(()=>{
                                    dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })}}>{ICONS.EMAIL}</Button>
              </Col>
            </Row>

    )
}

export const IPhone14SeriesDisclaimerFormSlider=({ticket}:DisclaimerFormProps)=> {
        const dispatch = useDispatch()
    const IPhone14SeriesDisclaimerFormPrint = PrintHOC(IPhone14SeriesDisclaimerForm, <span className="m-3">
        <> <Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email(
                          'iphone14_disclaimer').then(()=>{
                                   dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })}}>{ICONS.EMAIL}</Button>
          <ESignaturePane
              id={ticket.id}
              guid={ticket.guid}
              url={ticket.url}
              type={"iphone14_disclaimer"}
              code={ticket.reference_number}
          ></ESignaturePane></>
        </span>)

    return (
         <Row>
            <Col xs={10}>  <Slider style={{width:"100%"}}
                                   size={"md"} variant="dark" title="Iphone 14 & Above">
            <IPhone14SeriesDisclaimerFormPrint ticket={ticket}/>
        </Slider></Col>
              <Col xs={2}>
                  <Button size={"md"} variant="success" onClick={()=>{
                      new TicketService(ticket.url).send_disclaimer_by_email(
                          'iphone14_disclaimer').then(()=>{
                                   dispatch(showSuccessToast('Success', 'Disclaimer Sent Successfully.'))
                      })}}>{ICONS.EMAIL}</Button>
              </Col>
            </Row>
    )
}
